import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { format } from 'date-fns';

export function AuditPage(): JSX.Element {
  const query = useQuery({ queryKey: ['audit'], queryFn: () => api.listAudit(200) });

  return (
    <div className="space-y-4 max-w-5xl">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">Audit</h2>
        <p className="text-sm text-muted-foreground">
          Every destructive and external-effect action, ever. This log is never auto-pruned.
        </p>
      </div>

      <Card>
        {query.isLoading && <div className="p-6 text-sm text-muted-foreground">Loading…</div>}
        {query.data?.actions.length === 0 && (
          <div className="p-6 text-sm text-muted-foreground">No audited actions yet.</div>
        )}
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase text-muted-foreground border-b">
            <tr>
              <th className="px-4 py-2">When</th>
              <th className="px-4 py-2">Class</th>
              <th className="px-4 py-2">Integration</th>
              <th className="px-4 py-2">Tool</th>
              <th className="px-4 py-2">Approved by</th>
              <th className="px-4 py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {query.data?.actions.map((a) => (
              <tr key={a.id} className="border-b last:border-b-0">
                <td className="px-4 py-2 whitespace-nowrap">
                  {format(new Date(a.created_at), 'PPp')}
                </td>
                <td className="px-4 py-2">
                  <Badge
                    variant={a.action_class === 'destructive' ? 'destructive' : 'warning'}
                  >
                    {a.action_class}
                  </Badge>
                </td>
                <td className="px-4 py-2 font-mono text-xs">{a.integration}</td>
                <td className="px-4 py-2 font-mono text-xs">{a.tool}</td>
                <td className="px-4 py-2">{a.approved_by ?? '—'}</td>
                <td className="px-4 py-2">
                  <Badge variant="outline">{a.status}</Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
